<template>
  <v-btn
    v-if="allowed || !hideWhenDenied"
    :disabled="!allowed && disableWhenDenied"
    v-bind="$attrs"
    @click="$emit('click', $event)"
  >
    <slot />
  </v-btn>
</template>

<script setup>
import { computed } from "vue";
import { canControl } from "@/utils/permissions";

const props = defineProps({
  form: { type: String, required: true },
  control: { type: String, required: true },
  hideWhenDenied: { type: Boolean, default: false },
  disableWhenDenied: { type: Boolean, default: true },
});

// Default ON until real claims exist; also default ON if props are missing/empty.
const allowed = computed(() => {
  if (!props.form || !props.control) return true; // defensive
  const raw = localStorage.getItem("claims");
  if (!raw) return true;
  try {
    const arr = JSON.parse(raw);
    if (!Array.isArray(arr) || arr.length === 0) return true;
  } catch {
    return true;
  }
  return canControl(props.form, props.control);
});
</script>
